import React from 'react';
export function VolumesDetail() {
  const fisicaVols = [{
    vol: '📘 Vol. 1',
    content: 'Core Drills Academy — Feeding patterns, intensity rhythm, and ball-feeling foundations.'
  }, {
    vol: '📗 Vol. 2',
    content: 'Technical Masterclass — The visual biomechanics encyclopedia. Fix any stroke with 5-word cues.'
  }, {
    vol: '📕 Vol. 3',
    content: 'The Session Builder — The "3-6-10" scaling logic. Never fear uncertain group numbers again.'
  }, {
    vol: '📙 Vol. 4',
    content: 'Professional Blueprints — 50 complete sessions (Warm-up to Match-play) ready to plug & play.'
  }, {
    vol: '📘 Vol. 5',
    content: 'Match-Play & Strategy — The tactical vault. Club-level patterns and high-percentage winning tricks.'
  }, {
    vol: '📙 Vol. 6',
    content: 'The Elite Coach Business — Retention strategies, brand identity, and avoiding "coach burnout."'
  }];
  const bookEmojis = ['📘', '📗', '📕', '📙', '📘', '📙'];
  const formatVolText = (volText: string) => {
    return volText + ':';
  };
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border" data-id="element-256">
      <div className="max-w-5xl mx-auto" data-id="element-257">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-258">
          What you get in <span className="text-[#00FF84]" data-id="element-259">TENNIS READY</span>
        </h2>
        <div className="max-w-2xl mx-auto flex flex-col gap-8" data-id="element-260">
          <div className="bg-brand-card border border-brand-accent/40 rounded-2xl p-6 md:p-8" data-id="element-261">
            <div className="mb-6" data-id="element-262">
              <h3 className="text-xl md:text-2xl font-heading font-bold uppercase mb-1 text-[#00FF84]" data-id="element-263">
                ⚡ 6 Teaching Volumes (High-Quality PDF)
              </h3>
              <p className="text-white/70 text-sm" data-id="element-264">
                For professional tennis coaches and teaching pros
              </p>
            </div>
            <div className="space-y-5" data-id="element-265">
              {fisicaVols.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-266">
                  <span className="text-xl leading-none mt-0.5" data-id="element-267">
                    {bookEmojis[i]}
                  </span>
                  <p className="text-white/90 text-base leading-relaxed" data-id="element-268">
                    <span className="font-bold text-white mr-1" data-id="element-269">
                      {formatVolText(item.vol)}
                    </span>
                    {item.content}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}